(function () {
    'use strict';

    angular
        .module('app.mentionManagementLog')
        .controller('mentionManagementLogCtrl', ['$scope', '$rootScope', 'mentionManagementLogService', '$modal', 'adminService', 'influencerManagementLogService', 'TimelineService',
            function ($scope, $rootScope, mentionManagementLogService, $modal, adminService, influencerManagementLogService, timelineService) {
                $scope.user_id = 0;
                $scope.page_no = 1;
                $scope.page_size = 25;

                $scope.timeline = angular.copy(timelineService.logTimeline);
                $scope.timeline.forEach(function (val) {
                    val.ticked = false;
                });  
                $scope.timeline[2].ticked = true;

                var dateRange = timelineService.calculateDateRangeByLogTimeline($scope.timeline[2].value);
                $scope.from_date = dateRange.fromDate;
                $scope.to_date = dateRange.toDate;

                $scope.getAchooUsers = function() {
                    influencerManagementLogService.getAchooUsers(false)
                        .then(function(response) {
                            $scope.achooUsers = response.data;
                            $scope.achooUsers[0].ticked = true;
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getAchooUsers();

                $scope.selectUser = function(user) {
                    $scope.user_id = user.id;
                    $scope.getMentionManagementLog();
                    $scope.getNumberOfMentionManagementLog();
                    $scope.getNumberOfMentionApprovedAndApprovalRate();
                    $scope.getNumberOfTranslationsCompleted();
                }

                $scope.selectPeriod = function(period) {
                    var dateRange = timelineService.calculateDateRangeByLogTimeline(period.value);
                    $scope.from_date = dateRange.fromDate;
                    $scope.to_date = dateRange.toDate;
                    $scope.getMentionManagementLog();
                    $scope.getNumberOfMentionManagementLog();
                    $scope.getNumberOfMentionApprovedAndApprovalRate();
                    $scope.getNumberOfTranslationsCompleted();
                }

                $scope.updatePage = function(currentPage) {
                    $scope.page_no = currentPage;
                    $scope.getMentionManagementLog();
                    $scope.getNumberOfMentionManagementLog();
                    $scope.getNumberOfMentionApprovedAndApprovalRate();
                    $scope.getNumberOfTranslationsCompleted();
                }

                $scope.getMentionManagementLog = function() {
                    mentionManagementLogService.getMentionManagementLog($scope.user_id, $scope.from_date, $scope.to_date, $scope.page_no, $scope.page_size, true)
                        .then(function(response) {
                            $scope.mentionManagementLog = response.data;
                            $scope.mentionManagementLog.forEach(function (item) {
                                item.date = moment(item.date).format('YYYY-MM-DD hh:mm A');
                            });
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getMentionManagementLog();

                $scope.getNumberOfMentionManagementLog = function() {
                    mentionManagementLogService.getNumberOfMentionManagementLog($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function(response) {
                            $scope.number = response.data;
                            $scope.pagination();
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfMentionManagementLog();

                $scope.getNumberOfMentionApprovedAndApprovalRate = function() {
                    mentionManagementLogService.getNumberOfMentionApprovedAndApprovalRate($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function(response) {
                            $scope.mentionApproved = response.data.mention_approved;
                            $scope.approvalRate = response.data.approval_rate;
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfMentionApprovedAndApprovalRate();

                $scope.getNumberOfTranslationsCompleted = function() {
                    mentionManagementLogService.getNumberOfTranslationsCompleted($scope.user_id, $scope.from_date, $scope.to_date, true)
                        .then(function(response) {
                            $scope.translationsCompleted = response.data;
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getNumberOfTranslationsCompleted();

                $scope.mentionManagementLogDetailed = function(mention_management_log_id, mention_id) {
                    var mentionManagementLogDetailedModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/mention/mentionManagementLog/mentionManagementLogDetailed/mentionManagementLogDetailed.html?app_v=deployDate',
                        controller: 'mentionManagementLogDetailedCtrl',
                    });

                    $scope.mention_management_log_id = mention_management_log_id;
                    $scope.mention_id = mention_id;
                    $scope.mentionManagementLogDetailedModalInstance = mentionManagementLogDetailedModalInstance;
                    mentionManagementLogDetailedModalInstance.result.then(function() {
                        $scope.getMentionManagementLog();
                        $scope.getNumberOfMentionManagementLog();
                        $scope.getNumberOfMentionApprovedAndApprovalRate();
                        $scope.getNumberOfTranslationsCompleted();
                    })
                }

                $scope.pagination = function() {
                    $scope.pages = adminService.pagination($scope.number, $scope.page_size);
                };

                $scope.mentionDetail = function(mention_id) {
                    var mentionManagementLogMentionDetailsModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/mention/mentions/mentionDetail/mentionDetail.html?app_v=deployDate',
                        controller: 'mentionDetailCtrl',
                    });

                    $scope.id = mention_id;
                    $scope.mentionManagementLogMentionDetailsModalInstance = mentionManagementLogMentionDetailsModalInstance;
                    mentionManagementLogMentionDetailsModalInstance.result.then(function() {
                        $scope.getMentionManagementLog();
                        $scope.getNumberOfMentionManagementLog();
                        $scope.getNumberOfMentionApprovedAndApprovalRate();
                        $scope.getNumberOfTranslationsCompleted();
                    })
                }

            }
        ])
})();